export enum FocusPayProcessingRateType {
    FLATRATE = "flatRate",
    INTERCHANGE_PLUS = "interchangePlus",
    TIERED_RATE = "tieredRate",
}
